export default "__VITE_ASSET__BSZ7bC_9__"